import {frontageApiService} from "@/plugins/frontage-api.js"

export const showMessage = (message, options) => {
  return frontageApiService.get('toast-show-message',{message, options})
}
export const showSuccess = (message, options) => {
  return frontageApiService.get('toast-show-success',{message, options})
}
export const showWarning = (message, options) => {
  return frontageApiService.get('toast-show-warning',{message, options})
}
export const showError = (message, options) => {
  // also called show attention
  return frontageApiService.get('toast-show-error',{message, options})
}
export const showErrorWithAction = (message, options) => {
  return frontageApiService.get('toast-show-error-with-action',{message, options})
}
